const options = {
	ComplaintStatus: [
		{ value: "Active", label: "Active" },
		{ value: "Done", label: "Done" },
		{ value: "Pending", label: "Pending" },
	],
	ComplaintType: [
		{ value: "Hardware", label: "Hardware" },
		{ value: "Software", label: "Software" },
		{ value: "Networking", label: "Networking" },
		{ value: "Civil", label: "Civil" },
	],
	ComplaintSubType: [
		{ value: "Telephone", label: "Telephone" },
		{ value: "TV", label: "TV" },
		{ value: "HIS", label: "HIS" },
		{ value: "Mobile", label: "Mobile" },
		{ value: "Other", label: "Other" },
	],
	Gender: [
		{ value: "Male", label: "Male" },
		{ value: "Female", label: "Female" },
		{ value: "Other", label: "Other" },
	],
	ComplaintDepartment: [
		{ value: "Reception", label: "Reception" },
		{ value: "Nursing Male", label: "Nursing Male" },
		{ value: "Nursing Female", label: "Nursing Female" },
		{ value: "Security Gaurd", label: "Security Gaurd" },
		{ value: "Ward Aaya", label: "Ward Aaya" },
		{ value: "Ward Boy", label: "Ward Boy" },
		{ value: "House Keeping", label: "House Keeping" },
		{ value: "IT Department", label: "IT Department" },
		{ value: "Electrician", label: "Electrician" },
		{ value: "HR", label: "HR" },
		{ value: "Billing", label: "Billing" },
		{ value: "Account", label: "Account" },
		{ value: "Pharmacy", label: "Pharmacy" },
	],
	Banks: [
		{ value: "	Allahabad Bank	", label: "	Allahabad Bank	" },
		{ value: "	Andhra Bank	", label: "	Andhra Bank	" },
		{ value: "	Axis Bank	", label: "	Axis Bank	" },
		{
			value: "	Bank of Bahrain and Kuwait	",
			label: "	Bank of Bahrain and Kuwait	",
		},
		{
			value: "	Bank of Baroda - Corporate Banking	",
			label: "	Bank of Baroda - Corporate Banking	",
		},
		{
			value: "	Bank of Baroda - Retail Banking	",
			label: "	Bank of Baroda - Retail Banking	",
		},
		{ value: "	Bank of India	", label: "	Bank of India	" },
		{ value: "	Bank of Maharashtra	", label: "	Bank of Maharashtra	" },
		{ value: "	Canara Bank	", label: "	Canara Bank	" },
		{ value: "	Central Bank of India	", label: "	Central Bank of India	" },
		{ value: "	City Union Bank	", label: "	City Union Bank	" },
		{ value: "	Corporation Bank	", label: "	Corporation Bank	" },
		{ value: "	Deutsche Bank	", label: "	Deutsche Bank	" },
		{ value: "	Development Credit Bank	", label: "	Development Credit Bank	" },
		{ value: "	Dhanlaxmi Bank	", label: "	Dhanlaxmi Bank	" },
		{ value: "	Federal Bank	", label: "	Federal Bank	" },
		{ value: "	ICICI Bank	", label: "	ICICI Bank	" },
		{ value: "	IDBI Bank	", label: "	IDBI Bank	" },
		{ value: "	Indian Bank	", label: "	Indian Bank	" },
		{ value: "	Indian Overseas Bank	", label: "	Indian Overseas Bank	" },
		{ value: "	IndusInd Bank	", label: "	IndusInd Bank	" },
		{ value: "	ING Vysya Bank	", label: "	ING Vysya Bank	" },
		{ value: "	Jammu and Kashmir Bank	", label: "	Jammu and Kashmir Bank	" },
		{ value: "	Karnataka Bank Ltd	", label: "	Karnataka Bank Ltd	" },
		{ value: "	Karur Vysya Bank	", label: "	Karur Vysya Bank	" },
		{ value: "	Kotak Bank	", label: "	Kotak Bank	" },
		{ value: "	Laxmi Vilas Bank	", label: "	Laxmi Vilas Bank	" },
		{ value: "	Oriental Bank of Commerce	", label: "	Oriental Bank of Commerce	" },
		{
			value: "	Punjab National Bank - Corporate Banking	",
			label: "	Punjab National Bank - Corporate Banking	",
		},
		{
			value: "	Punjab National Bank - Retail Banking	",
			label: "	Punjab National Bank - Retail Banking	",
		},
		{ value: "	Punjab & Sind Bank	", label: "	Punjab & Sind Bank	" },
		{
			value: "	Shamrao Vitthal Co-operative Bank	",
			label: "	Shamrao Vitthal Co-operative Bank	",
		},
		{ value: "	South Indian Bank	", label: "	South Indian Bank	" },
		{
			value: "	State Bank of Bikaner & Jaipur	",
			label: "	State Bank of Bikaner & Jaipur	",
		},
		{ value: "	State Bank of Hyderabad	", label: "	State Bank of Hyderabad	" },
		{ value: "	State Bank of India	", label: "	State Bank of India	" },
		{ value: "	State Bank of Mysore	", label: "	State Bank of Mysore	" },
		{ value: "	State Bank of Patiala	", label: "	State Bank of Patiala	" },
		{ value: "	State Bank of Travancore	", label: "	State Bank of Travancore	" },
		{ value: "	Syndicate Bank	", label: "	Syndicate Bank	" },
		{
			value: "	Tamilnad Mercantile Bank Ltd.	",
			label: "	Tamilnad Mercantile Bank Ltd.	",
		},
		{ value: "	UCO Bank	", label: "	UCO Bank	" },
		{ value: "	Union Bank of India	", label: "	Union Bank of India	" },
		{ value: "	United Bank of India	", label: "	United Bank of India	" },
		{ value: "	Vijaya Bank	", label: "	Vijaya Bank	" },
		{ value: "	Yes Bank Ltd	", label: "	Yes Bank Ltd	" },
	],
	cashBankOption: [
		{ value: "Cash", label: "Cash" },
		{ value: "Bank", label: "Bank" },
	],
};
export default options;
